export default __webpack_public_path__ + "static/media/card-visa.97d5c996.svg";